import jwtDecode from "jwt-decode";
import { getLoggedInUser } from "../../helpers/auth/authUtils";
import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCESS,
  CLEAR_CHANGE_PASSWORD_MESSAGE,
  CLEAR_ERROR_AND_SUCCESSFUL,
  CLEAR_FORGOT_PASSWORD_MESSAGE,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_FAILED,
  FORGOT_PASSWORD_SUCCESS,
  LOGIN_USER,
  LOGIN_USER_FAILED,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_SUCCESS,
  SET_USER_INFO,
  SIGNIN,
  SIGNIN_FAILED,
  SIGNIN_SUCCESS,
  SIGN_IN_GUEST,
  SIGN_IN_GUEST_FAILED,
  SIGN_IN_GUEST_SUCCESS,
} from "./constants";

const getInitState = () => {
  const { jwtAuthToken, user } = getLoggedInUser();
  return {
    jwtAuthToken,
    user,
    loading: false,
    error: false,
    successfulLoginOrSignIn: false,
  };
};

const Auth = (state = getInitState(), action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true };
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        jwtAuthToken: action.payload.jwtAuthToken,
        user: jwtDecode(action.payload.jwtAuthToken),
        loading: false,
        successfulLoginOrSignIn: true,
      };
    case LOGIN_USER_FAILED:
      return { ...state, error: true, loading: false };
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        jwtAuthToken: null,
        jwtGuestToken: null,
        user: null,
        loading: false,
        error: false,
        successfulLoginOrSignIn: false,
        forgotPasswordMsg: null,
        changePasswordMsg: null,
        conversations: [],
      };
    case FORGOT_PASSWORD:
      return { ...state, loading: true };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordMsg: "success",
        loading: false,
      };
    case FORGOT_PASSWORD_FAILED:
      return {
        ...state,
        forgotPasswordMsg: "error",
        loading: false,
      };
    case CLEAR_FORGOT_PASSWORD_MESSAGE:
      return { ...state, forgotPasswordMsg: null };
    case CHANGE_PASSWORD:
      return { ...state, loading: true };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordMsg: "success",
        loading: false,
      };
    case CHANGE_PASSWORD_FAILED:
      return {
        ...state,
        changePasswordMsg: "error",
        loading: false,
      };
    case CLEAR_CHANGE_PASSWORD_MESSAGE:
      return { ...state, changePasswordMsg: null };
    case SIGNIN:
      return { ...state, loading: true };
    case SIGNIN_SUCCESS:
      return {
        ...state,
        jwtAuthToken: action.payload.jwtAuthToken,
        user: jwtDecode(action.payload.jwtAuthToken),
        loading: false,
        successfulLoginOrSignIn: true,
      };
    case SIGNIN_FAILED:
      return {
        ...state,
        error: true,
        errorMsg: action.payload.errorMsg,
        loading: false,
      };
    case SIGN_IN_GUEST:
      return { ...state, loading: true };
    case SIGN_IN_GUEST_SUCCESS:
      return {
        ...state,
        jwtGuestToken: action.payload.jwtGuestToken,
        user: jwtDecode(action.payload.jwtGuestToken),
        loading: false,
      };
    case SIGN_IN_GUEST_FAILED:
      return {
        ...state,
        error: true,
        loading: false,
      };
    case CLEAR_ERROR_AND_SUCCESSFUL:
      return {
        ...state,
        error: false,
        errorMsg: null,
        successfulLoginOrSignIn: false,
      };
    case SET_USER_INFO:
      return {
        ...state,
        [action.payload.tokenType]: action.payload.jwtToken,
        user: jwtDecode(action.payload.jwtToken),
      };
    default:
      return { ...state };
  }
};

export default Auth;
